'use client';

import Link from 'next/link';
import React from 'react';

import {Button} from '@/components/ui/button';

interface UnAuthenticatedUserModalProps {
    onClose?: () => void;
    modalId?: string;
}

export const UnAuthenticatedUserModal: React.FC<UnAuthenticatedUserModalProps> = ({
                                                                                      onClose,
                                                                                  }) => {
    return (
        <div className="p-6">
            <div className="my-6 w-full space-y-4">
                <h3 className="text-center font-sans text-[38px] font-extrabold leading-[48px] text-motitoBlack">
                    Start your journey to alternative finance
                </h3>

                <p className="mt-6 pt-4 text-center leading-[24px]">
                    Thank you for choosing motito paylater. Register or login to
                    complete your order using motito.
                </p>
            </div>

            <div className="flex flex-col items-center justify-center gap-y-2">
                <Link href="/sign-up" className="w-full" onClick={onClose}>
                    <Button
                        size="lg"
                        className="w-full rounded-full bg-motitoBlue text-white"
                    >
                        Create an account
                    </Button>
                </Link>

                <p className="relative inline-block text-base leading-[24px] text-black-100">
                    OR
                </p>

                <Link href="/sign-in" className="w-full" onClick={onClose}>
                    <Button
                        size="lg"
                        variant="outline"
                        className="w-full rounded-full"
                    >
                        Login
                    </Button>
                </Link>
            </div>
        </div>
    );
};

UnAuthenticatedUserModal.displayName = 'UnAuthenticatedUserModal';

export default UnAuthenticatedUserModal;